export const maximumAvailableProductionHoursForAllSites = (
  numberSites,
  maximumUptimePotentialPerSite
) => {
  return numberSites * maximumUptimePotentialPerSite;
};

export const downtimeHours = (maximumAvailableProductionHours, currentUptime) => {
  return maximumAvailableProductionHours * (1 - currentUptime / 100);
}

export const downtimeCosts = (downtimeHours, averageDowntimeCostPerHour) => {
  return downtimeHours * averageDowntimeCostPerHour;
}

export const reverseCurrentServiceLevel = (currentServiceLevel) => {
  return 1 - Number(currentServiceLevel) / 100;
}

export const reverseRecommendedServiceLevel = (recommendedServiceLevel) => {
  return 1 - recommendedServiceLevel / 100;
}

export const optimizedDowntimeHours = (reverseRecommendedServiceLevel, downtimeHours, reverseCurrentServiceLevel) => {
  return (reverseRecommendedServiceLevel * downtimeHours) / reverseCurrentServiceLevel;
}

export const optimizedDowntimeCosts = (optimizedDowntimeHours, averageDowntimeCostPerHour) => {
  return optimizedDowntimeHours * averageDowntimeCostPerHour;
}

export const avoidableDowntimeCosts = (downtimeCosts, optimizedDowntimeCosts) => {
  return downtimeCosts - optimizedDowntimeCosts;
}

export const potentialAvoidableDowntimeWithVerusen = (avoidableDowntimeCosts, riskAdjustment) => {
  return avoidableDowntimeCosts * riskAdjustment;
}
